<template>
  <div class="left-side-column" v-if="token" :style="{ width: sidebarWidth }">
    <div id="nav-bar" class="nlhpc-sidebar l-navbar" :class="{ show: isSidebarOpen }">
      <nav class="nav d-flex">
        <button
          class="nlhpc-ham cruz-nav col-2 navbar-toggler"
          type="button"
          @click="toggleSidebar"
          style="margin-top: 60px"
        >
          <i
            :class="[
              'nav_icon',
              'float-center',
              'mx-1',
              'fa-2xl',
              'fa-solid',
              sidebarIcon,
            ]"
          ></i>
        </button>

        <div class="col-10">
          <div class="" style="margin-top: 60px">
            <a href="#" class="nav_link">
              <span class="mb-4"></span>
            </a>

            <div id="mainSidebar" class="nav_list" :style="{ width: sidebarWidth }">
              <router-link to="/" :class="{ nav_link: true, active: routePath === '/' }">
                <i class="fas fa-xl fa-tachometer-alt nav_icon"></i>
                <span class="nav_name">Dashboard</span>
              </router-link>

              <router-link
                to="/noticias"
                :class="{ nav_link: true, active: routePath.includes('noticias') }"
              >
                <i class="fas fa-xl fa-bullhorn nav_icon"></i>
                <span class="nav_name">Noticias</span>
              </router-link>

              <router-link
                v-if="user?.admin"
                to="/administracion"
                :class="{ nav_link: true, active: routePath.includes('administracion') }"
              >
                <i class="fa-solid fa-xl fa-gear nav_icon"></i>
                <span class="nav_name">Administración</span>
              </router-link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import "@/assets/css/sidebar.css";

export default {
  name: "MainSidebar",
  data() {
    return {
      user: null,
      isSidebarOpen: false,
      sidebarWidth: "68px",
    };
  },
  props: {
    token: {
      type: String,
      default: null,
    },
  },
  computed: {
    routePath() {
      return this.$route.path;
    },
    sidebarIcon() {
      return this.isSidebarOpen ? "fa-arrow-left" : "fa-bars";
    },
  },
  created() {
    this.user = this.$nlhpc.getUser();
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;

      const windowWidth = window.innerWidth;

      if (windowWidth >= 612) {
        this.sidebarWidth = this.isSidebarOpen ? "223.031px" : "68px";

        // Puedes animar con CSS transitions en vez de jQuery animate
        const mainCol = document.querySelector(".main-column");
        if (mainCol) {
          mainCol.style.transition = "padding-left 0.3s linear";
          mainCol.style.paddingLeft = this.sidebarWidth;
        }
      }
    },
  },
};
</script>

<style scoped>
.left-side-column {
  transition: width 0.3s linear;
}
</style>
